import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';
import {
    DevicesRepository,
    MeRepository,
    LicensesRepository,
    ActivationCodesRepository,
    TransactionsRepository,
    AppIntegrationsRepository,
    PaymentTypesRepository,
    dwmRepository,
    // AppPricesRepository,
} from 'common/repositories/index';
import PaymentTypesNotifications from 'common/notifications/-RFC.paymentTypesNotifications';

const _serviceDependencies = ['$scope', '$state', '$rootScope', '$window', 'Auth', 'Util', '$http', 'JWT'];
const EU_WITHDRAW_WINDOW_DAYS = 14;

class Dashboard {

    /**
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} $rootScope
     * @param  {any} $window
     * @param  {any} $state
     * @param  {any} Auth
     */

    constructor($scope, $state, $rootScope, $window, Auth, Util, $http, JWT) {

        this.$rootScope = $rootScope;
        this.$rootScope.State.finishedLoadingAnimation = true;
        this.$state = $state;
        this.$scope = $scope;

        this.Util = Util;

        this.$rootScope.showCmaDisclaimer = {
            otc: false,
            trial: false,
            banner: false,
            cardDeleted: false,
            withdrawalConsent: false,
        };

        const user = MeRepository.getMyUser();
        const isNewUser = Util.deepFind(user, 'attributes.password_not_set');
        const gdprConfirmed = Util.deepFind(user, 'attributes.gdpr_confirm');
        const usCompliance = user.attributes.status_us_compliance_approved;
        const primaryLocaleSelector = `${user.attributes.language}-${user.attributes.country}`;
        let secondaryLocaleSelector = user.attributes.language;
        $rootScope.accountCountry = Util.deepFind(user, 'attributes.country');
        angular.lowercase = text => text.toLowerCase();

        // if the user lanuge is English and the user is
        // not from US, show our default format (DD/MM/YYY)
        if (secondaryLocaleSelector === 'en' &&
            (user.attributes.country !== 'US')) {

            secondaryLocaleSelector = 'en-gb';

        }

        // set locale for moment js in order to show the correct date format
        moment.locale([primaryLocaleSelector, secondaryLocaleSelector]);

        /* This method prevents the user from accessing dashboard homepage if
            the user clicks on the back button from browser
            or is accessing the homepage route directly and his account is not
            confirmed or doesn't have a password.
        */
        if (!gdprConfirmed || gdprConfirmed === '') {

            Auth.gotoConfirm();

        } else if (isNewUser) {

            Auth.gotoSetPassword();

        }

        // Suppress renewal touchpoints when src=mobileApp (Google Play Store compliance)
        $rootScope.isMobileAppSession = document.cookie.split('; ').some(c => c === 'oe_mobile_session=1');

        // Check if dashboard should be full visible based on US compliance status
        if ($rootScope.isComingFromEmbargoedCountry) {

            $rootScope.hasUsCompliance = false;

        } else if (usCompliance === false) {

            $rootScope.hasUsCompliance = false;

        } else {

            $rootScope.hasUsCompliance = true;

        }

        // Sort licenses alphabetically by acronym
        const sortLicenses = data => data.sort((a, b) => {

            const firstAcronym = Util.deepFind(a, 'relationships.app.data.id');
            const secondAcronym = Util.deepFind(b, 'relationships.app.data.id');

            if (firstAcronym < secondAcronym) {

                return -1;

            }
            if (firstAcronym > secondAcronym) {

                return 1;

            }
            return 0;

        });

        // Update mixpanel super properties
        let licenses;
        let activationCodes;
        let licensesAcronyms;
        let licensesNames;
        let runtimesRemaining;
        let subscriptionStatuses;
        let subscriptionTypes;
        let subscriptionRuntimes;

        const setMixpanelCommonProperties = () => {

            licensesAcronyms = [];
            licensesNames = [];
            runtimesRemaining = [];
            subscriptionStatuses = [];
            subscriptionTypes = [];
            subscriptionRuntimes = [];

            licenses = LicensesRepository.getAll();
            activationCodes = ActivationCodesRepository.getAll();
            const transactions = TransactionsRepository.getAll();
            const paymentTypeValues = [];

            const sortedLicenses = sortLicenses(licenses);
            sortedLicenses.forEach((license) => {

                const acronym = Util.deepFind(license, 'relationships.app.data.id');
                const app = AppIntegrationsRepository.getById(acronym);
                const appName = Util.deepFind(app, 'attributes.resource.oeName');
                const subscriptionType = license.attributes.subscription_type;
                // Get remaining days
                const expirationDate = Util.deepFind(license, 'attributes.expiration_date');
                const startTime = moment();
                const endTime = moment(expirationDate);
                const difference =
                    parseInt(moment.duration(endTime.diff(startTime)).asDays(), 10) + 1;
                const runtime = Util.deepFind(license, 'attributes.runtime');

                // Get the corresponding activation code in order to determine subscription type
                const licenseActivationCode = Util.deepFind(license, 'relationships.activation-code.data.id');
                const activationCode =
                    activationCodes.find(code => code.id === licenseActivationCode);
                if (licenseActivationCode && activationCode) {

                    const isStaticOTC = activationCode.attributes.subscription === 0 &&
                        (
                            activationCode.attributes.subscription_type === 'yearly' ||
                            activationCode.attributes.subscription_type === 'prepaid'
                        );
                    const isVoucher = TransactionsRepository.isVoucherPurchase(activationCode.id);

                    if (!isStaticOTC && !isVoucher) {

                        if (activationCode.attributes.subscription === 0 && activationCode.attributes.type !== 'eval') {

                            subscriptionStatuses.push('Auto-Renewal OFF');

                        } else if (activationCode.attributes.subscription === 1 && activationCode.attributes.type !== 'eval') {

                            subscriptionStatuses.push('Auto-Renewal ON');

                        }

                    } else if (isStaticOTC) {

                        this.$rootScope.showCmaDisclaimer.otc = true;
                        subscriptionStatuses.push('Static OTC');

                    } else if (isVoucher) {

                        subscriptionStatuses.push('Voucher');

                    }

                } else if (license.attributes.type === 'eval') {

                    this.$rootScope.showCmaDisclaimer.trial = true;
                    subscriptionStatuses.push('Trial');

                }

                if (activationCode && transactions.length > 0) {

                    const transactionId = transactions
                        .find(transaction =>
                            transaction.attributes.activation_code === activationCode.id);
                    if (transactionId) {

                        paymentTypeValues.push(Util.deepFind(transactionId, 'attributes.payment_type'));

                    }

                }

                licensesAcronyms.push(acronym);
                licensesNames.push(appName);
                runtimesRemaining.push(difference);
                subscriptionTypes.push(subscriptionType);
                subscriptionRuntimes.push(runtime);

            });

            let licenseType = 'free';

            const hasTrial = licenses.find(license => license.attributes.type === 'eval');
            const hasPaid = licenses.find(license => license.attributes.type === 'paid');

            if (hasTrial && hasPaid) {

                licenseType = 'paid';

            } else if (hasTrial && !hasPaid) {

                licenseType = 'trial';

            } else if (!hasTrial && hasPaid) {

                licenseType = 'paid';

            }
            // a/b test unsubscribe animation
            // only apply for paid users
            if (activationCodes.length > 0 && CWCONFIG.unsubscribeAnimation) {

                if (localStorage.getItem('animation') === 'true') {

                    $rootScope.State.unsubscribeAnimation = true;

                    Mixpanel.setCommonProperty('A/B Test unsubscribe animation', true);

                } else {

                    $rootScope.State.unsubscribeAnimation = false;
                    Mixpanel.setCommonProperty('A/B Test unsubscribe animation', false);

                }

            }
            // verify if user has an valid payment method
            const paymentTypes = PaymentTypesRepository.getAll();
            const validPayment = paymentTypes.findIndex((payment) => {

                const paymentType = Util.deepFind(payment, 'attributes.payment_type');
                const isVoucherPayment = paymentType ? paymentType.toLowerCase().indexOf('voucher') > -1 : false;

                const paymentExpirationDate = Util.deepFind(payment, 'attributes.expiration_date');
                if (paymentExpirationDate && paymentExpirationDate.indexOf('-') > -1) {

                    return !PaymentTypesNotifications.isCardExpired(payment, 0);

                }
                if (Util.isPaymentCardDeleted(payment)) {

                    this.$rootScope.showCmaDisclaimer.cardDeleted = true;
                    return false;

                }
                return !isVoucherPayment;

            });
            const validPaymentMethod = !!(paymentTypes.length > 0 && validPayment > -1);
            $rootScope.hasValidPayment = validPaymentMethod;

            Mixpanel.setCommonProperty('License Type', licenseType);
            Mixpanel.setCommonProperty('License Count', licenses.length);
            Mixpanel.setCommonProperty('Licenses', licensesAcronyms);
            Mixpanel.setCommonProperty('Licenses Names', licensesNames);
            Mixpanel.setCommonProperty('Runtimes Remaining', runtimesRemaining);
            Mixpanel.setCommonProperty('Runtimes Remaining Min', runtimesRemaining.length > 0 ? Math.min(...runtimesRemaining) : 'None');
            Mixpanel.setCommonProperty('Runtimes Remaining Max', runtimesRemaining.length > 0 ? Math.max(...runtimesRemaining) : 'None');
            Mixpanel.setCommonProperty('Subscription Statuses', subscriptionStatuses);
            Mixpanel.setCommonProperty('Subscription Types', subscriptionTypes);
            Mixpanel.setCommonProperty('Valid Payment Method', validPaymentMethod ? 'yes' : 'no');
            Mixpanel.setCommonProperty('Subscription Runtimes', subscriptionRuntimes);
            Mixpanel.setCommonProperty('Payment Type', paymentTypeValues);

            // A/B Test Identity Assistant Banner
            // const hasPrime =
            //    LicensesRepository.getLicenseByAppId('aps10') ||
            //    LicensesRepository.getLicenseByAppId('aps20');
            // const hasIdentityAssistant = LicensesRepository.getLicenseByAppId('adwp1');
            // const country = Util.deepFind(MeRepository.getMyUser(), 'attributes.country');

            // if (country === 'DE' && !hasPrime && !hasIdentityAssistant) {

            //    if (!localStorage.getItem('IdentityAssistantBanner')) {

            //        localStorage.setItem('IdentityAssistantBanner',
            //            Math.floor(Math.random() * 2));

            //    }

            //    const testGroup =
            //        localStorage.getItem('IdentityAssistantBanner') === '0' ? 'control' : 'test';
            //    Mixpanel.setCommonProperty('AB Test', testGroup);

            // }

            // A/B Test Auto-Renew Offer
            // const autoRenewOfferEligibleIds = [];
            // const isTestEnabled = CWCONFIG.enableAutoRenewDiscountABtest;

            // const hasPrimeOn = activationCodes
            //     .find(activationCode => ((activationCode.attributes.app ===
            // 'aps10' && activationCode.attributes.subscription === 1) ||
            // (activationCode.attributes.app === 'aps20' &&
            // activationCode.attributes.subscription === 1)));

            // $rootScope.autoRenewOfferEligibleIds = [];
            // activationCodes.forEach((activationCode) => {

            //     const transactionId = transactions
            //         .find(transaction =>
            //             transaction.attributes.activation_code === activationCode.id);

            //     let paymentType;
            //     if (transactionId) {

            //         paymentType =
            //             paymentTypes.find(payment =>
            //                 payment.id === transactionId.attributes.payment_transaction_id);

            //     }

            //     const isCardDeleted = Util.isPaymentCardDeleted(paymentType);
            //     const hasActivePromotion = activationCode.attributes.promotion_id;
            //     const appId = activationCode.attributes.app;
            //     const subscriptionStatus = activationCode.attributes.subscription;
            //     const isStaticOTC = subscriptionStatus === 0 &&
            //     (
            //         activationCode.attributes.subscription_type === 'yearly' ||
            //         activationCode.attributes.subscription_type === 'prepaid'
            //     );
            //     const isVoucher = TransactionsRepository.isVoucherPurchase(activationCode.id);
            //     const { runtime } = activationCode.attributes;

            //     if (((appId === 'aps10' || appId === 'aps20') ||
            // (((appId === 'aapd5' || appId === 'aapd0') && runtime > 1))) &&
            //         (!isStaticOTC && !isVoucher && !isCardDeleted) &&
            //         subscriptionStatus === 0 && !hasActivePromotion && isTestEnabled &&
            //         !hasPrimeOn) {

            //         autoRenewOfferEligibleIds.push(activationCode.id);

            //         if (!localStorage.getItem('testAutoRenewDiscountReview')) {

            //             const randomValueTest = Math.floor(Math.random() * 3) + 1;
            //             let testGroupRenewOffer = '';

            //             if (randomValueTest === 1) {

            //                 testGroupRenewOffer = 'control';

            //             } else if (randomValueTest === 2) {

            //                 testGroupRenewOffer = 'activate';

            //             } else if (randomValueTest === 3) {

            //                 testGroupRenewOffer = 'save';

            //             }

            //             localStorage.setItem('testAutoRenewDiscountReview', testGroupRenewOffer);

            //         }

            //     }

            // });

            // $rootScope.autoRenewOfferEligibleIds = autoRenewOfferEligibleIds;
            // localStorage.setItem('autoRenewOfferEligibleIds',
            // JSON.stringify(autoRenewOfferEligibleIds));

        };

        eventManager.subscribe('purchase completed', () => {

            setMixpanelCommonProperties();

        });

        const subjectActivationCodes = ActivationCodesRepository.getObservable();
        const activationCodesSubscriber = subjectActivationCodes
            .subscribe(
                () => setMixpanelCommonProperties(),
                () => { },
                () => { },
            );

        const devices = DevicesRepository.getVisibleDevices();

        const userRegistrationDate = Util.deepFind(user, 'attributes.date_registered');
        const today = moment();
        const registrtionDate = moment(userRegistrationDate);
        const accountDays =
                parseInt(moment.duration(today.diff(registrtionDate)).asDays(), 10) + 1;

        // let autoRenewOfferVersion;
        // if ($rootScope.autoRenewOfferEligibleIds.length === 0) {

        //     autoRenewOfferVersion = 'Not qualified';

        // } else if (localStorage.getItem('testAutoRenewDiscountReview')) {

        //     autoRenewOfferVersion = localStorage.getItem('testAutoRenewDiscountReview');

        // }

        // Country detection code
        const userDetails = MeRepository.getMyUser();
        const userCountry = userDetails.attributes.country;
        $rootScope.accountCountry = userCountry;

        if ($rootScope.requestCountry === 'GB' || $rootScope.accountCountry === 'GB') {

            $rootScope.cmaGBapplies = true;

        }

        if ($rootScope.requestCountry === 'US' || $rootScope.accountCountry === 'US') {

            $rootScope.cmaUSapplies = true;

        }

        if ($rootScope.requestCountry === 'NL' || $rootScope.accountCountry === 'NL') {

            $rootScope.cmaNLapplies = true;

        }

        if ($rootScope.requestCountry === 'IN' && !localStorage.getItem('disclaimerBar')) {

            $rootScope.vpnINdisclaimer = true;

        }

        if ($rootScope.requestCountry === 'DE' || $rootScope.accountCountry === 'DE') {

            $rootScope.cmaDEapplies = true;

        }

        if ($rootScope.requestCountry === 'FR' || $rootScope.accountCountry === 'FR') {

            $rootScope.cmaFRapplies = true;

        }

        const { eeaCountriesList, euWithdrawalConsentCountryCodes } = CWCONFIG.cma;

        $rootScope.isPartOfEEA = !!(
            eeaCountriesList.find(country => country.code === $rootScope.requestCountry) ||
            eeaCountriesList.find(country => country.code === $rootScope.accountCountry)
        );

        const isPartOfEU = euWithdrawalConsentCountryCodes.includes($rootScope.requestCountry) ||
            euWithdrawalConsentCountryCodes.includes($rootScope.accountCountry);

        const allSubscriptions = [...(licenses || []), ...(activationCodes || [])];
        const hasRecentEuPurchase = allSubscriptions.some((item) => {

            const dateCreate = Util.deepFind(item, 'attributes.creation_date');
            const type = Util.deepFind(item, 'attributes.type');
            const subscriptionType = Util.deepFind(item, 'attributes.subscription_type');
            if (!dateCreate || type !== 'paid' || subscriptionType.indexOf('trial') > -1) return false;
            const daysDiff = moment().diff(moment(dateCreate), 'days');
            return daysDiff >= 0 && daysDiff <= EU_WITHDRAW_WINDOW_DAYS;

        });
        $rootScope.euWithdrawalConsentEligible = isPartOfEU && hasRecentEuPurchase;

        // End country detection code

        // Hide subscriptions widget from homepage
        const hasATrial = licenses.length;
        const hasAPaidLicense = activationCodes.length;
        if ((hasAPaidLicense || hasATrial) && !$rootScope.cmaGBapplies) {

            $rootScope.hideHomepageSubscriptionWidget = true;

        } else {

            $rootScope.hideHomepageSubscriptionWidget = false;

        }
        // End hide subscriptions widget from homepage

        if (!$rootScope.cmaGBapplies) {

            $rootScope.showSubscriptionsLinkInMyAccountDropdown = true;

        }

        Mixpanel.setCommonProperty('Devices Count', devices.length);
        Mixpanel.setCommonProperty('Account days', accountDays);

        let testGroup;
        if (!$rootScope.showAIAWelcomeOfferBanner) {

            testGroup = 'Not qualified';

        } else {


            if (!localStorage.getItem('aiaBannerVariant')) {

                localStorage.setItem(
                    'aiaBannerVariant',
                    Math.floor(Math.random() * 2),
                );

            }

            testGroup =
                localStorage.getItem('aiaBannerVariant') === '0' ? 'control' : 'test';

        }

        $rootScope.aiaBannerVariant = testGroup;
        Mixpanel.setCommonProperty('A/B Test AIA Banner Learn More', testGroup);

        Mixpanel.send('ConnectWeb Home Open', {
            'Devices OS': devices.map(device => device.attributes.os).filter(os => os).sort(),
            Source: Auth.loginSource || 'Direct',
            'Login Type': Auth.loginType || 'Refresh',
            Restricted: $rootScope.hasUsCompliance === false ? 'true' : 'false',
        });

        Auth.sendAcpPing();

        // save the login details object on local storage
        Util.updateLastLoginObjectInLocalStorage(user);

        $scope.$on('$stateChangeSuccess', (event, toState, fromParam, fromState) => {

            // scroll page up when state changes
            if (toState.name.indexOf('ltb') === -1 && fromState.name.indexOf('ltb') === -1) {

                $window.scrollTo(0, 0);

            }

        });

        if (localStorage.getItem('theme') === 'dark') {

            $rootScope.State.theme = 'dark';

        } else {

            $rootScope.State.theme = 'light';

        }

        // show welcome modal if coming from spotlight campaign
        if ($rootScope.isFromSpotlightNewsletterCampaign === true) {

            // open spotlight welcome modal only for en and de
            if (CWCONFIG.language === 'en' ||
                CWCONFIG.language === 'de') {

                this.$state.go('root.dashboard.home.ltb', {
                    ltb: 'welcome-modal-spotlight',
                    resourceId: 'aps10',
                });

            }

            /* remove TrialSourceSpotlight sessionStorage in order to show
               the welcome modal only once */
            sessionStorage.removeItem('TrialSourceSpotlight');

        }

        // broadcast when the user mouseover the sidebar
        $scope.broadcastMouseOver = () => {

            eventManager.broadcast('mainControlls:hover');

        };

        $rootScope.mobileMenuAttribute = 'open-mobile-menu';

        eventManager.subscribe('zendesk-chat:started', () => {

            if (window.zE) {

                window.zE('webWidget:on', 'chat:end', () => {

                    Mixpanel.send('ConnectWeb Chat Closed');

                });

            }

        });

        $rootScope.cryptoCurrency = localStorage.getItem('CryptoCurrency') ?
            localStorage.getItem('CryptoCurrency') : 'USD';

        let nortonGuid;
        const token = Util.getToken();

        if (token) {

            const decodedToken = JWT.getTokenPayload(token);

            if ('aguid' in decodedToken) {

                nortonGuid = decodedToken.aguid;

            }

        }

        $rootScope.hideCryptoTab = true;
        const { cryptoRestApi } = CWCONFIG;
        if (CWCONFIG.showCrypto) {

            $http({
                method: 'GET',
                url: `${cryptoRestApi}/wallet/api/balance/${nortonGuid}/`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'x-nlok-user-agent': 'ConnectWeb/1.0/Web',
                },

            }).then((response) => {

                if ($state.current.name === 'root.dashboard.crypto' ||
                    response.data.wallets.ETH.balance !== 0) {

                    $rootScope.hideCryptoTab = false;

                }

            }).catch((error) => {

                if ($state.current.name === 'root.dashboard.crypto') {

                    $rootScope.hideCryptoTab = false;

                } else {

                    $rootScope.hideCryptoTab = true;

                }

                if (error.status !== 404) {

                    Mixpanel.send('ConnectWeb Crypto Error', {
                        'Error Code': error.status,
                        'Error Name': error.data ? error.data : 'No error message',
                        Resource: 'GET balance',
                    });

                }

            });

        } else {

            $rootScope.hideCryptoTab = true;
            if ($state.current.name === 'root.dashboard.crypto') {

                $state.go('root.dashboard.home');

            }

        }

        // Code for displaying the DWM feature
        // if (CWCONFIG.dwm.showFeature) {

        //     this.$rootScope.showDWM = false;
        //     const dwmSupportedCountries = CWCONFIG.dwm.availableCountries;
        //     const isInSupportedCountries =
        //         dwmSupportedCountries.find(country => country === $rootScope.accountCountry);
        //     const hasDwmLicense = activationCodes.find(activationCode =>
        // activationCode.attributes.app === 'adwp1');
        //     const hasPrimeLicense = activationCodes.find(activationCode =>
        // activationCode.attributes.app === 'aps10' || activationCode.attributes.app === 'aps20');

        //     if (isInSupportedCountries || hasDwmLicense || hasPrimeLicense) {

        //         this.$rootScope.showDWM = true;

        //     }

        // }

        // OE-7619-cw-add-free-trial-card-when-users-are-dropping-the-purchase-process-in-cw
        const hasPrimeTrial = licenses.find(license => license.relationships.app.data.id === 'aps10' || license.relationships.app.data.id === 'aps20');
        const hasPrimeLicense = activationCodes.find(activationCode => activationCode.attributes.app === 'aps10' || activationCode.attributes.app === 'aps20');

        if (!hasPrimeTrial && !hasPrimeLicense) {

            $rootScope.showPrimeTrialModal = true;

        }
        // OE-7619-cw-add-free-trial-card-when-users-are-dropping-the-purchase-process-in-cw


        const aviraToken = Util.getToken();

        const aiaStatusApiCall = () => {

            if (!$rootScope.showDwmLeftNavigation && window.location.pathname.indexOf('/dashboard/identity-assistant/') === -1) {

                $http({
                    method: 'POST',
                    url: CWCONFIG.dwm.statusURL,
                    headers: {
                        Authorization: `Bearer ${aviraToken}`,
                    },
                    data: {
                        clientApplication: {
                            clientId: 'myavira',
                        },
                    },

                }).then((response) => {

                    const dwmStatus = response.data || {};
                    $rootScope.dwmStatus = dwmStatus;

                    // root.hideAIACardInFreeStore
                    const aiaTileAction = Util.deepFind(dwmStatus, 'products.identityAssist.tileAction');
                    const dwmLiteTileAction = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.tileAction');

                    if (aiaTileAction === 'openUpsell') {

                        $rootScope.showAIACardInFreeStore = true;

                    }

                    if (aiaTileAction === 'openUpsell' || dwmLiteTileAction === 'openUpsell') {

                        $rootScope.showAIAWelcomeOfferBanner = true;

                    } else {

                        $rootScope.showAIAWelcomeOfferBanner = false;

                    }

                    const aiaStatus = Util.deepFind(dwmStatus, 'products.identityAssist');
                    const dwmLiteStatus = Util.deepFind(dwmStatus, 'products.dwmLite');

                    const aiaSubscriptionStatus = Util.deepFind(dwmStatus, 'products.identityAssist.subscriptionStatus');
                    const dwmLiteSubscriptionStatus = Util.deepFind(dwmStatus, 'products.dwmLite.subscriptionStatus');

                    const aiaSubscriptionCancelled = aiaSubscriptionStatus === 'cancelled' || aiaSubscriptionStatus === 'none';
                    const dwmLiteSubscriptionCancelled = dwmLiteSubscriptionStatus === 'cancelled' || dwmLiteSubscriptionStatus === 'none';

                    if ((aiaStatus || dwmLiteStatus)
                        && (aiaSubscriptionCancelled ||
                            dwmLiteSubscriptionCancelled)) {

                        $rootScope.showDwmCardHomepage = true;

                    } else {

                        $rootScope.showDwmCardHomepage = false;

                    }

                    dwmRepository.replace('statusApi', dwmStatus);

                    if (aiaStatus || dwmLiteStatus) {

                        $rootScope.showDwmLeftNavigation = true;

                    }

                    $rootScope.dwmStatusLoaded = true;

                }).catch(() => {

                    $rootScope.showDwmLeftNavigation = false;
                    $rootScope.dwmStatusLoaded = true;

                });

            }

        };

        const purchaseListenerAia = $rootScope.$on('dwm_purchase_completed', () => {

            aiaStatusApiCall();

        });

        const purchaseListenerPrime = $rootScope.$on('prime_purchase_completed', () => {

            aiaStatusApiCall();

        });


        // End code for displaying the DWM feature

        //* Promotional Campaign : Create a global variable for displaying CMA disclaimer
        //* To be commented when the campaign is over
        // $rootScope.welcomeOffers = {};
        // $rootScope.createCMAlabels =
        //     (productId, productName, productAcronym, startDate, endDate) => {

        //         const firstYearPriceDetails = $rootScope.firstYearPrices[productAcronym];

        //         const formattedStartDate = new Date(startDate).getTime();
        //         const formattedEndDate = new Date(endDate).getTime();

        //         const currentAppPrices =
        //         AppPricesRepository.getSinglePrice(productAcronym, 12, 1);

        //         // do not show disclaimer for unsubscribe flexible promotion
        //         const promotionCode =
        //         this.Util.deepFind(currentAppPrices, 'attributes.promotion.code')
        //         const isUnsubscribePromotion = promotionCode === 'cw_unsubscribe_20';
        //         if (isUnsubscribePromotion) {

        //             return;

        //         }

        //         const currentPrice =
        // this.Util.deepFind(currentAppPrices, 'attributes.promotion.price');

        //         // Start code for banner label
        //         const pcPrice =
        //         this.Util.deepFind(firstYearPriceDetails, 'attributes.total_price');

        //         const firstYearPrice =
        // this.Util.deepFind(firstYearPriceDetails, 'attributes.total_price_string');

        //         const discountedPrice =
        //         this.Util.deepFind(currentAppPrices, 'attributes.promotion.total_price_string');

        //         const pcPriceString =
        //         this.Util.deepFind(currentAppPrices, 'attributes.promotion.pc_price_string');

        //         const promotionCurrency =
        //         this.Util.deepFind(currentAppPrices, 'attributes.promotion.currency');

        //         let currency = '';

        //         let priceDiff = Math.round(pcPrice - currentPrice).toFixed(2);

        //         if (discountedPrice) {

        //             currency = discountedPrice
        //                 .replace(/[0-9]/g, '').replace(/\./g, '').replace(/,/g, '');
        //             if (promotionCurrency === 'RUB') {

        //                 currency = currency.replace(/\s/g, '');
        //                 priceDiff =
        //     `${Math.round(pcPrice - currentPrice).toFixed(2)} ${currency}`;

        //             } else if (discountedPrice.indexOf(currency) > 0) {

        //                 priceDiff =
        //     `${Math.round(pcPrice - currentPrice).toFixed(2)}${currency}`;

        //             } else {

        //                 priceDiff =
        //     `${currency}${Math.round(pcPrice - currentPrice).toFixed(2)}`;

        //             }

        //         }

        //         $rootScope.welcomeOffers[productId] =
        //         {
        //             discountedPrice,
        //             firstYearPrice,
        //             product: productName,
        //             discountedAmount: priceDiff,
        //             renewalPrice: pcPriceString,
        //             startDate: moment(formattedStartDate).format('L'),
        //             endDate: moment(formattedEndDate).format('L'),
        //         };

        //     };

        $scope.$on('$destroy', () => {

            purchaseListenerAia();
            purchaseListenerPrime();
            activationCodesSubscriber.dispose();

        });

    }


    toggleMobileMenu() {

        this.$rootScope.showMobileMenu = !this.$rootScope.showMobileMenu;

        if (this.$rootScope.showMobileMenu) {

            this.$rootScope.mobileMenuAttribute = 'close-mobile-menu';

        } else {

            this.$rootScope.mobileMenuAttribute = 'open-mobile-menu';

        }

    }


}

_serviceDependencies.push(Dashboard);

angular.module('controllers')
    .controller('Dashboard', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/dashboard.js